<ng-container *ngIf="canView">

    <!--Selector comunidades/edificios-->
    <div *ngIf="listaComunidades.length > 1"><!--Si solo hay una comunidad, no se mostrará el select-->
        <div *ngIf="listaComunidades" style="text-align: center; margin-bottom: -10px;">
            <mat-form-field class="mat-form-field-selector-comunidades" appearance="outline">
                <mat-label>{{getTraduccion('Comunidad')}}</mat-label>
                <mat-select (selectionChange)="onComunidadSelect($event)" [(value)]="seleccionComunidadActual">
                    <mat-option [value]="0">Ver Todos</mat-option>
                    <mat-option *ngFor="let s of listaComunidades" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    
    <!--Lista de publicaciónes-->
    <div fxLayout="row stretch" class="zb-readonly" *ngIf="listaPublicaciones != null && listaPublicaciones.length > 0">
        <div fxFlex="100" fxFlex.xs="100" class="flex-item" *ngFor="let publicacion of listaPublicaciones">
            <mat-card class="mat-card-publicaciones">
                <div class="contenedor-card">
                    <div class="contenedor-card-imagen">
                        <img *ngIf="publicacion.ImagenPortadaUrl" [src]="publicacion?.ImagenPortadaUrl">
                        <img *ngIf="!publicacion.ImagenPortadaUrl" src="../../../../assets/edificio.default.webp">
                    </div>
                    <div class="contenedor-card-info">
                        <div class="card-info" >
                            <h2>{{sharedFunctions.getOnlyTextFromHtml(publicacion.Titulo)}}</h2>
                            <p><i>{{publicacion.FechaCreacion | date:'dd/MM/yyyy'}}</i></p>
                        </div>
                        <div class="comunidad-info">
                            <p [innerHTML]="publicacion.ComunidadNombre"></p>
                        </div>
                        <p>{{getTruncatedText(sharedFunctions.getOnlyTextFromHtml(publicacion.Descripcion), 150)}}</p>
                        <a class="publicaciones-anchor" (click)="view(publicacion)">Ver publicación</a>
                    </div>
                </div>
            </mat-card>
        </div>
    </div>
    
    <div>
        <div fxFlex=100 fxFlex.xs=100 class="flex-item">
            <div fxLayout="row stretch" fxLayout.xs="column" fxLayoutAlign="center center" style="text-align: center;">
                <button mat-raised-button (click)="onSearch()" [ngStyle]="{'width': (isMobile ? '100%' : 'auto')}" class="zb-button" [disabled]="isSearching || isEndOfList">{{isSearching ? 'Cargando...' : 'Ver más publicaciones'}}</button>
            </div>
        </div>
    </div>

</ng-container>